import React, { useEffect, useState } from "react";
//libraries from here
import {
  Button,
  TextField,
  Grid,
  Checkbox,
  FormControlLabel,
  FormGroup,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  FormHelperText,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { fetchMethod } from "../../FetchMethod";
import { saveTreatmentHistory } from "./PatientQuery";
import SnackBarComponent from "../../SnackBar/SnackBar";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import StarRoundedIcon from "@material-ui/icons/StarRounded";
let headers = {
  paddingLeft: "12px",
  paddingBottom: "12px",
  paddingRight: "12px",
  margin: "0px",
  color: "black",
};

// ----------------------------REFRENCES---------------------------
// -------------------- 1 : Main Container (Treatment History(TMM001))
// -------------------- 2 : Comment Addition (TMMCA1)
// -------------------- 3 : CheckBox HandleChange (ADTHCH210)
// -------------------- 4 : TreatMent History (TRTH4660)
const SAVE = "Save";
const ADDTREATMENT = "Add Treatment";
const useStyles = makeStyles((theme) => ({
  mainRoot: {
    color: "dodgerblue",
    "& > *": {
      color: "dodgerblue",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "dodgerblue",
      },
    },
    "& .MuiOutlinedInput-root-focused": {
      "& fieldset": {
        borderColor: "dodgerblue",
      },
      "&:hover fieldset": {
        borderColor: "dodgerblue",
      },
      "&.Mui-focused fieldset": {
        borderColor: "dodgerblue",
      },
    },

    "& label.Mui-focused": {
      color: "dodgerblue",
    },
  },

  root: {
    background: "#0070c0",
    borderRadius: 3,
    border: 0,
    color: "white",
    height: 35,
    // padding: '0 px',
    width: 100,
    // boxShadow: "0 3px 5px 2px rgba(255, 105, 135, .3)",
    textTransform: "none",
    "&:hover": {
      background: "#0070c0",
    },
  },
  AddTreatmentCSS: {
    background: "#0070c0",
    borderRadius: 3,
    border: 0,
    color: "white",
    height: 40,
    // padding: '0 px',
    width: 120,
    // boxShadow: "0 3px 5px 2px rgba(255, 105, 135, .3)",
    textTransform: "none",
    "&:hover": {
      background: "#0070c0",
    },
  },
  checkBoxChecked: {
    background: "#0070c0",
    borderRadius: "8px",
    color: "white",
    padding: "6px",
    height: "35px",
    "& svg": { opacity: 0 },
    "& span:nth-of-type(2)": { marginLeft: "-40px", padding: "2px" },
  },
  checkBoxUnChecked: {
    background: "white",
    color: "black",
    borderRadius: "8px",
    padding: "6px",
    height: "35px",
    border: "2px solid #0070c0",
    "& svg": { opacity: 0 },
    "& span:nth-of-type(2)": { marginLeft: "-40px", padding: "2px" },
  },
}));

function TreatMentHistorySection({
  Add = false,
  historyData = [],
  renderTreatmentHistoryEdit,
  ctscanid,
  Permission,
  getTreatmentHistory,
}) {
  const classes = useStyles();
  const [parentState, setParentState] = useState(undefined),
    [renderEdit, setRenderEdit] = useState(false),
    [open, setOpen] = useState(false),
    [alertmsg, setAlertMsg] = useState(""),
    [errorMsg, setErrorMsg] = useState({});

  useEffect(() => {
    // console.log("=====PARENT STATE :",parentState)
  }, [parentState]);

  return (
    <div
      style={{
        // background: "pink",
        display: "flex",
        flexDirection: "column",

        // marginTop: "-50px",
        // marginLeft: "80px",
      }}
      className="TreatmentHistorySection"
    >
      <h4>Treatment History</h4>

      {historyData.length == 0 ? (
        Add ? (
          ""
        ) : (
          <h6>No Treatment History Recorded.</h6>
        )
      ) : (
        ""
      )}

      {/* Main Container (TMM001) */}
      <div
        className="TreatmentHistoryContainer"
        // style={{
        //   padding: "12px",

        // }}
      >
        {historyData.map((Thistory, index) => {
          return renderEdit.id === Thistory.id && renderEdit ? (
            <AddTreatmentHistory
              Add={Add}
              parentState={parentState}
              setParentState={setParentState}
              history={renderEdit}
              key={index}
              errorMsg={errorMsg}
            />
          ) : (
            <TreamentHistory
              setRenderEdit={setRenderEdit}
              Thistory={Thistory}
              getTreatmentHistory={getTreatmentHistory}
              renderTreatmentHistoryEdit={renderTreatmentHistoryEdit}
              key={index}
            />
          );
        })}
        {Add ? (
          <AddTreatmentHistory
            Add={Add}
            parentState={parentState}
            setParentState={setParentState}
            errorMsg={errorMsg}
          />
        ) : (
          ""
        )}
        {/* <TreamentHistory />
        <TreamentHistory />
        <TreamentHistory />
        <TreamentHistory />
        <TreamentHistory /> */}
      </div>
      {/* Main Container (TMM001) */}
      <div
        style={{
          // paddingLeft: "20px",
          display: "flex",
          justifyContent: "flex-start",
          flexWrap: "wrap",
        }}
      >
        {renderEdit || Add ? (
          <FormHelperText
            style={{ marginBottom: "10px", width: "100%", fontSize: "14px" }}
          >
            <span style={{ fontWeight: "bolder" }}>
              <StarRoundedIcon
                style={{
                  fontSize: "16px",
                  position: "relative",
                  bottom: "4px",
                }}
              />
              WARNING
            </span>
            : Do not include Protected Health Information (PHI) in comments.
          </FormHelperText>
        ) : (
          ""
        )}
        <Button
          disabled={Permission}
          className={
            renderEdit
              ? classes.root
              : Add
              ? classes.root
              : classes.AddTreatmentCSS
          }
          onClick={async (e) => {
            if (renderEdit) {
              if (
                parentState.treatmentdate !== null &&
                parentState.segments !== ""
              ) {
                let result = await fetchMethod(saveTreatmentHistory, {
                  obj: { id: parentState.id, ...parentState },
                }).then((res) => res.json());
                setOpen(true);
                setAlertMsg("Treatment history edited successfully.");
                renderTreatmentHistoryEdit(Add);
                getTreatmentHistory();
                setRenderEdit(false);
              } else {
                const error = {};
                if (parentState.treatmentdate === null)
                  error.treatmentdate = "Treatment Date is Mandatory.";
                if (parentState.segments === "")
                  error.segments = "Segment(s) is mandatory.";
                setErrorMsg(error);
                return;
              }
            }
            if (Add) {
              if (parentState.treatmentdate && parentState.segments) {
                let response = await fetchMethod(saveTreatmentHistory, {
                  obj: { ctscanid: ctscanid, ...parentState },
                }).then((res) => res.json());
                if (response.data.saveTreatmenthistory) {
                  setParentState({});
                  renderTreatmentHistoryEdit(Add);
                  getTreatmentHistory();
                  setOpen(true);
                  setAlertMsg("Treatment history added successfully.");
                } else {
                  console.error(response.errors, "Error");
                }
              } else {
                const error = {};
                if (!parentState.treatmentdate)
                  error.treatmentdate = "Treatment Date is Mandatory.";
                if (!parentState.segments)
                  error.segments = "Segment(s) is mandatory.";
                setErrorMsg(error);
              }
            } else {
              renderTreatmentHistoryEdit(Add);
            }
          }}
        >
          {renderEdit ? SAVE : Add ? SAVE : ADDTREATMENT}
        </Button>
        {open ? (
          <SnackBarComponent
            severity={"success"}
            open={open}
            alertmsg={alertmsg}
            timer={2000}
            handleClose={() => {
              setOpen(false);
            }}
            className="addUserSnackBar"
          />
        ) : (
          ""
        )}
      </div>
    </div>
  );
}

const AddTreatmentHistory = ({
  Add = false,
  parentState,
  setParentState,
  history = false,
  errorMsg,
}) => {
  const classes = useStyles();
  const [state, setState] = React.useState({
      rb1: false,
      rb2: false,
      rb3: false,
      lb1: false,
      lb2: false,
      lb3: false,
      lb4: false,
    }),
    [segments, setSegments] = React.useState(""),
    [txDate, setTxDate] = React.useState(undefined),
    [comment, setComment] = React.useState(undefined),
    [makeEdits, setMakeEdits] = React.useState(Add);
  const { rb1, rb2, rb3, lb1, lb2, lb3, lb4 } = state;

  const handleChange = (event) => {
    event.preventDefault();
    setState({ ...state, [event.target.name]: event.target.checked });

    let seg;
    seg = segments;
    if (seg === "") {
      seg = segments + event.target.name + ",";
    }
    if (segments.indexOf(event.target.name) > -1) {
      seg = seg.replace(event.target.name + ",", "");
    } else {
      seg = segments + event.target.name + ",";
    }
    setSegments(seg);
    setMakeEdits(true);
    setParentState({ ...parentState, segments: seg });
  };
  const handleComment = (event) => {
    event.preventDefault();
    if (event.target.value.length < 100) {
      setParentState({ ...parentState, comments: event.target.value });
      setComment(event.target.value);
      setMakeEdits(true);
    }
  };

  useEffect(() => {
    if (makeEdits == false) {
      // console.log("===State=====", state);
      let { segments: SEGMENTS, treatmentdate: TREATMENT_DATE } = history;
      if (TREATMENT_DATE) {
        // if(TREATMENT_DATE!=null)
        setTxDate(TREATMENT_DATE.slice(0, 19).replace("T", " ").split(" ")[0]);
      } else {
        setTxDate("");
      }
      let SEGMENTS_MAIN = SEGMENTS ? SEGMENTS.split(",") : [];
      // console.log("====Sel=",k)
      let segmentsObject = { ...state };
      SEGMENTS_MAIN.map((item) => {
        if (item != "") {
          segmentsObject[item] = true;
        }
      });
      setSegments(SEGMENTS ? SEGMENTS : "");
      setState(segmentsObject);
      // setState({...state,[SEGMENTS]:true})
      // setState({"rb1":true})
    }
    setParentState({ ...parentState, id: history.id });
  }, [segments]);

  return (
    <>
      {/* className={classes.container} */}
      <form noValidate>
        <div
          className="txDateContainer"
          style={{ display: "flex ", flexWrap: "wrap" }}
        >
          <label>
            {/* padding: "25px", paddingRight: "35px" */}
            Tx Date :
          </label>

          <TextField
            className={classes.mainRoot}
            id="date"
            type="date"
            variant="outlined"
            inputProps={{ max: new Date().toISOString().split("T")[0] }}
            value={makeEdits ? (txDate != null ? txDate : "") : txDate}
            onKeyPress={e=>e.preventDefault()}
            onChange={(e) => {
              let selectedDate = new Date(e.target.value.toString());
              selectedDate =
                selectedDate instanceof Date && !isNaN(selectedDate)
                  ? selectedDate.toISOString().slice(0, 19).replace("T", " ")
                  : null;
              setTxDate(e.target.value);
              setParentState({ ...parentState, treatmentdate: selectedDate });
              setMakeEdits(true);
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
          {errorMsg ? (
            errorMsg.treatmentdate ? (
              <FormHelperText style={{ margin: "0px 80px" }}>
                {errorMsg.treatmentdate}
              </FormHelperText>
            ) : (
              ""
            )
          ) : (
            ""
          )}
        </div>

        {/* Check Boxes */}
        <div
          className="treatmentSegments"
          // style={{
          //   display: "flex",
          //   width: "100%",
          //   marginBottom: "8px",
          //   justifyContent: "space-evenly",
          // }}
        >
          <div>
            <label
            // style={{ width: "120px" }}
            >
              Segment(s):
            </label>
            <FormGroup>
              {/*style={{width:"100px" }}  */}
              {/* <div> */}
              <FormControlLabel
                className={
                  rb1 ? classes.checkBoxChecked : classes.checkBoxUnChecked
                }
                control={
                  <Checkbox checked={rb1} onChange={handleChange} name="rb1" />
                }
                label="RB1"
              />
              <FormControlLabel
                className={
                  rb2 ? classes.checkBoxChecked : classes.checkBoxUnChecked
                }
                control={
                  <Checkbox checked={rb2} onChange={handleChange} name="rb2" />
                }
                label="RB2"
                labelStyle={{ color: "white" }}
                iconStyle={{ fill: "white" }}
              />
              <FormControlLabel
                className={
                  rb3 ? classes.checkBoxChecked : classes.checkBoxUnChecked
                }
                control={
                  <Checkbox checked={rb3} onChange={handleChange} name="rb3" />
                }
                label="RB3"
              />
              <FormControlLabel
                className={
                  lb1 ? classes.checkBoxChecked : classes.checkBoxUnChecked
                }
                control={
                  <Checkbox checked={lb1} onChange={handleChange} name="lb1" />
                }
                label="LB1"
              />
              <FormControlLabel
                className={
                  lb2 ? classes.checkBoxChecked : classes.checkBoxUnChecked
                }
                control={
                  <Checkbox checked={lb2} onChange={handleChange} name="lb2" />
                }
                label="LB2"
              />
              <FormControlLabel
                className={
                  lb3 ? classes.checkBoxChecked : classes.checkBoxUnChecked
                }
                control={
                  <Checkbox checked={lb3} onChange={handleChange} name="lb3" />
                }
                label="LB3"
              />
              <FormControlLabel
                className={
                  lb4 ? classes.checkBoxChecked : classes.checkBoxUnChecked
                }
                control={
                  <Checkbox checked={lb4} onChange={handleChange} name="lb4" />
                }
                label="LB1+2"
              />
              {/* </div> */}
            </FormGroup>
          </div>
          {errorMsg ? (
            errorMsg.segments ? (
              <FormHelperText style={{ margin: "0px 80px" }}>
                {errorMsg.segments}
              </FormHelperText>
            ) : (
              ""
            )
          ) : (
            ""
          )}
        </div>
        {/* Comment Addition (TMMCA1) */}
        <div className="addComment" style={{ display: "flex" }}>
          <label>Comments :</label>
          <Grid sm={6} xs={6}>
            <TextField
              multiline={true}
              name="comment"
              required={true}
              // label="Organization"
              fullWidth
              onChange={handleComment}
              // onChange={handleChange}
              value={makeEdits ? comment : history.comments}
              variant="outlined"
              rowsMax="4"
            />
          </Grid>
        </div>
        {/* Comment Addition (TMMCA1) */}
      </form>
    </>
  );
};

const DeleteIcon = () => {
  return (
    <svg
      style={{ fill: " #f10000" }}
      xmlns="http://www.w3.org/2000/svg"
      width="15.75"
      height="18"
      viewBox="0 0 15.75 18"
    >
      <defs></defs>
      <path
        className="a"
        d="M15.187,1.125H10.969l-.33-.657A.844.844,0,0,0,9.882,0H5.864a.834.834,0,0,0-.752.468l-.33.657H.562A.562.562,0,0,0,0,1.687V2.812a.562.562,0,0,0,.562.562H15.187a.562.562,0,0,0,.562-.562V1.687A.562.562,0,0,0,15.187,1.125ZM1.87,16.418A1.687,1.687,0,0,0,3.554,18H12.2a1.687,1.687,0,0,0,1.684-1.582L14.625,4.5H1.125Z"
      />
    </svg>
  );
};

// TreatMent History (TRTH4660)

let TreatMentHistoryCSS = {
  sameLine: { display: "flex", margin: "5px", padding: "5px" },
  sameLineContentJustified: {
    display: "flex",
    margin: "5px",
    padding: "5px",
    justifyContent: "space-between",
  },
  sameLineNoSpacing: { display: "flex" },
  separationSpace: { paddingLeft: "8px", paddingRight: "5px" },
  labelWidth: { width: "100px" },
};
const TreamentHistory = ({
  Thistory,
  setRenderEdit,
  getTreatmentHistory,
  renderTreatmentHistoryEdit,
}) => {
  let { id, segments, comments } = Thistory;
  if (segments != undefined || segments != null)
    segments = Thistory.segments.replace("lb4", "lb1+2");

  const [deleteModalOpen, setdeleteModalOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [expand, setExpand] = useState(false);
  useEffect(() => {}, []);

  return (
    <div className="TreatmentHistory">
      <div className="txdate">
        <div>
          <label>Tx Date:</label>
          <div className="value">
            {new Date(Thistory.treatmentdate).toISOString().split("T")[0]}
          </div>
        </div>
        <IconButton
          className="editicon"
          onClick={(event) => {
            event.preventDefault();
            // console.log("---- ID ", id);
            //Re-Render EditComponent
            renderTreatmentHistoryEdit(false, true);
            setRenderEdit(Thistory);
          }}
        >
          <EditIcon />
        </IconButton>
      </div>
      <div className="segmentPart">
        <label>Segment(s):</label>
        <div className="value">
          {segments != null ? segments.toUpperCase().replace(/,\s*$/, "") : ""}
        </div>
      </div>
      <div className="comments-treatment">
        <div>
          <label>Comments:</label>
          {/* style={TreatMentHistoryCSS.separationSpace} */}
          <div className="comments-part">
            {comments && comments.length > 40 && !expand ? (
              <span>
                {comments.substring(0, 40)}{" "}
                <ExpandMoreIcon onClick={() => setExpand(true)} />
              </span>
            ) : (
              <span>
                {comments}{" "}
                {comments && comments.length > 40 ? (
                  <ExpandLessIcon onClick={() => setExpand(false)} />
                ) : (
                  ""
                )}
              </span>
            )}
          </div>
        </div>
        <IconButton
          className="deleteicon"
          onClick={(event) => {
            setdeleteModalOpen(true);
          }}
        >
          <DeleteIcon />
        </IconButton>

        <Dialog
          open={deleteModalOpen}
          onClose={() => {
            setdeleteModalOpen(false);
          }}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">Confirm</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete this item?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              autoFocus
              onClick={() => {
                setdeleteModalOpen(false);
              }}
              className="cancelbtn"
            >
              Cancel
            </Button>
            <Button
              onClick={async () => {
                // console.log("-----Deleting File----", Thistory.id);
                let response = await fetchMethod(saveTreatmentHistory, {
                  obj: { id: Thistory.id, active: 0 },
                }).then((res) => res.json());
                // console.log("===Deleted successfully !");
                setdeleteModalOpen(false);
                setOpen(true);
              }}
              autoFocus
              className="confirmbtn"
            >
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
        {open ? (
          <SnackBarComponent
            severity={"success"}
            open={open}
            alertmsg={"Treatment history deleted successfully."}
            timer={2000}
            handleClose={() => {
              setOpen(false);
              getTreatmentHistory();
            }}
            className="addUserSnackBar"
          />
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

// TreatMent History (TRTH4660)

const EditIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <defs></defs>
      <path
        className="a"
        d="M4.5,18.747V22.5H8.249L19.308,11.438,15.558,7.688ZM22.207,8.538a1,1,0,0,0,0-1.41l-2.34-2.34a1,1,0,0,0-1.41,0l-1.83,1.83,3.749,3.749Z"
        transform="translate(-4.5 -4.496)"
      />
    </svg>
  );
};

export default TreatMentHistorySection;
